// Prospecto oficial (EPAR, sin modificar) por fármaco e idioma. Los PDFs se
// sirven como archivos estáticos desde public/prospectos/. null = todavía no
// disponible en ese idioma.
// IMPORTANTE: nunca añadir un fragmento #page=N/#section=... a estas rutas —
// deben abrir siempre desde la primera página, tal cual el documento original.
export const PROSPECTO_URLS = {
  'Semaglutida (Ozempic / Wegovy)': {
    es: '/prospectos/semaglutida_es.pdf',
    en: '/prospectos/semaglutida_en.pdf',
  },
  'Tirzepatida (Mounjaro / Zepbound)': {
    es: '/prospectos/tirzepatida_es.pdf',
    en: '/prospectos/tirzepatida_en.pdf',
  },
  'Liraglutida (Saxenda)': null,
  'Dulaglutida (Trulicity)': null,
  'Otro': null,
};

export function getProspectoUrl(drug, lang = 'es') {
  const entry = PROSPECTO_URLS[drug];
  if (!entry) return null;
  const shortLang = (lang || 'es').slice(0, 2);
  return entry[shortLang] || entry.es || entry.en || null;
}
